import React, { useEffect } from "react";
import Header2 from "../header/Header2";
import paymentImg from "./public/PaymentSuccess.png";
import Footer from "../footer/Footer";
import { useNavigate } from "react-router-dom";

const PaymentSuccess = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const timer = setTimeout(() => {
            navigate("/passengersTrips");
        }, 2500);

        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <div className="mk-page mk-payment-success min-h-screen bg-[#f7f8fc] flex flex-col justify-between">
            <div>
                <Header2 />

                <main className="mx-auto w-[92%] max-w-[760px] py-10 md:py-6">
                    <section className="rounded-[20px] border border-slate-200 bg-white px-8 py-9 text-center shadow-[0_8px_30px_rgba(24,31,65,0.06)] md:px-4">
                        <div className="mx-auto flex h-[66px] w-[66px] items-center justify-center rounded-full bg-[#ecfbf3] text-[30px] text-[#21965b]">
                            ✓
                        </div>

                        <h1 className="mt-5 text-[22px] font-semibold text-slate-900">
                            درخواست شما با موفقیت ثبت شد
                        </h1>
                        <p className="mx-auto mt-2 max-w-[460px] text-[14px] leading-7 text-slate-500">
                            پرداخت ثبت شده و اطلاعات سفر در بخش «سفرهای من» قابل مشاهده است.
                        </p>

                        <img
                            src={paymentImg}
                            alt="پرداخت موفق"
                            className="mx-auto mt-4 h-auto w-[280px] max-w-full"
                        />

                        <button
                            type="button"
                            onClick={() => navigate("/passengersTrips")}
                            className="mt-3 h-[48px] min-w-[220px] rounded-[11px] bg-[#4F48EC] px-6 text-white md:w-full"
                        >
                            مشاهده سفرهای من
                        </button>
                    </section>
                </main>
            </div>

            <Footer />
        </div>
    );
};

export default PaymentSuccess;